import {Component, OnInit, OnDestroy} from '@angular/core';
import {Router} from '@angular/router';
import {ChangeRequestVO, HistoryHelperService, RequestMetadata, TopLevelDomainVO} from 'common-domain';
import {PATH_CONSTANTS} from '../../../app-routing.module';
import {USER_PATH_CONSTANTS} from '../../user-routing.module';
import {ChangeRequestService, CountriesListService} from 'common-domain';
import {Title} from '@angular/platform-browser';
import {UserDomainService} from '../../services/user-domain.service';


@Component({
  selector: 'home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss']
})
export class HomePageComponent implements OnInit, OnDestroy {
  newDelegationDomains: string[] = [];
  filterOptions = [
    {key: 'OPEN', value: 'Open'},
    {key: 'CLOSED', value: 'Closed'},
    {key: 'ALL', value: 'All'}];
  filterOptionSelected: string;
  searchText: string;
  private readonly FILTER_KEY = 'userdashboard';
  pageNumber = 0;
  totalPages = -1;

  constructor(private router: Router, private changeRequestService: ChangeRequestService, private titleService: Title, private userDomainService: UserDomainService, private countriesListService: CountriesListService, private historyHelperService: HistoryHelperService) {
  }

  changeRequests: ChangeRequestVO[] = [];

  ngOnInit() {
    this.titleService.setTitle('View Domains & Change Requests');
    this.getUndelegatedDomains();
    this.countriesListService.load();

    let filterHistory = this.historyHelperService.getHistory(this.FILTER_KEY);
    if (filterHistory == null) {
      this.filterOptionSelected = this.filterOptions[0].key;
      this.searchText = '';
    } else {
      this.filterOptionSelected = filterHistory.filterOptionSelected;
      this.searchText = filterHistory.searchText;
    }

    this.filter(this.searchText);
  }

  private getUndelegatedDomains() {
    this.userDomainService.getUserNewDelegationTLDS().subscribe(data => {
      if (data != null) {
        this.newDelegationDomains = data.response;
      }
    }, () => {
      console.log('Unable to retrive undelegagted domains');
    }, () => {

    });
  }

  changeFilter() {
    this.resetAllFields();
    this.filter('');
  }

  search() {
    this.resetAllFields();
    this.filter(this.searchText.trim());
  }

  filter(searchText: string) {
    if (this.totalPages === -1 || this.pageNumber < this.totalPages) {
      this.changeRequestService.getListOfChangeRequests(this.pageNumber, 25, this.filterOptionSelected, searchText, true).subscribe(data => {
        if (data != null) {
          this.changeRequests.push(...data.response);
          this.totalPages = data.totalPages;
        }
      }, () => {
        console.log('Unable to retrive change requests');
      }, () => {
      });
    }
  }

  onKeydown(event) {
    if (event.key === 'Enter') {
      this.search();
    }
  }

  navigateToRequestDetailsPage(changeRequest: ChangeRequestVO) {
    this.router.navigateByUrl(PATH_CONSTANTS.USER + PATH_CONSTANTS.SLASH + USER_PATH_CONSTANTS.REQUEST_DETAILS + changeRequest.id);
  }

  editDomain(request: ChangeRequestVO) {
    const domainId = request.tldId;
    let domain: TopLevelDomainVO = {};
    this.userDomainService.getDomainByID(domainId).subscribe(data => {
      domain = data;
    }, () => {
    }, () => {
      const requestMetadata: RequestMetadata = {
        domainName: domain.name.toLowerCase().trim() === '.' ? 'root' : domain.name.toLowerCase().trim(),
        requestType: 'UPDATE',
        submissionOriginType: 'Web',
        dateOfSubmission: ''
      };

      this.router.navigate([`/domain/create-request/` + domainId], {
        state: {
          requestMetadata: requestMetadata,
          domain: domain
        }
      });

    });
  }

  ngOnDestroy(): void {
    const history = {
      searchText: this.searchText,
      filterOptionSelected: this.filterOptionSelected
    };

    this.historyHelperService.storeHistory(this.FILTER_KEY, history);
  }

  onScroll() {
    if (this.changeRequests.length > 0) {
      this.pageNumber++;
      this.filter(this.searchText);
    }
  }

  private resetAllFields() {
    this.changeRequests = [];
    this.pageNumber = 0;
    this.totalPages = -1;
  }
}
